import React, { useEffect, useState } from 'react'
import styles from "./feedback.module.css"
import List from './list'
import Modal from "../modal";
import NewFeedback from './newFeedback';
import { notify } from '../toast';
import { GetAllReviews } from '../../utils/reviews';

const Feedback = () => {

  
  const DUMMY_DATA = [
    {
      rating: 5,
      comment: "Ačiū Edita už puikų masažą,ta ibuvo tikrai terapija ne tik kūnui bet ir sielaii🥰"
    },
    {
      rating: 5,
      comment: "Nuostabi ir maloni meistrė, kuri išmano savo darbą,  su malonumu lankausi ir džiaugiuosi vizitais . Visada  pasitinka su šypsena. Rekomenduoju ! 👍🌸"
    },
    {
      rating: 5,
      comment: "Labai rekomenduoju, puiki patirtis, Edita viską daro is širdies ir tas labai jaučiasi. Kaina nesikandzioja o kokybė 100%"
    },
  ]

  const [showPopUp, setShowPopUp] = useState(false);
  const [reviewsArray, setReviewsArray] = useState(DUMMY_DATA);
  const [onRefresh, setOnRefresh] = useState(false)
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {

    const fetchReviews = async() => {

      try {
        const response = await GetAllReviews();

        if(!response.status || !response.data) throw new Error(response.message);

        if(response.data.length > 0){
          setReviewsArray([...response.data,...reviewsArray])
        }
        else
          setReviewsArray(DUMMY_DATA)
                  
        setIsLoading(false)

      } catch (error) {
        setIsLoading(false)
        return notify(error.message, "error")
      }
    }

    fetchReviews()
  }, [onRefresh])



  return (
    <>
      {
        showPopUp &&
        <Modal
          show={showPopUp}
          onClose={()=>{setShowPopUp(false)}}
        > 
          <NewFeedback onRefresh={()=>{setOnRefresh(!onRefresh); setShowPopUp(false)}} />
        </Modal>
      }
      <div className={styles.container}>
        <h1>Klientų atsiliepimai</h1>
        <h2 onClick={()=>{setShowPopUp(true)}}>Pridėti</h2>
        {
          isLoading || !reviewsArray ?
          <h1>Loading...</h1>
          :
          <List onRefresh={()=>{setOnRefresh(!onRefresh)}} data={reviewsArray}/>
        }
      </div>
    </>
  )
}

export default Feedback